import React from "react";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { profile } from "../mock";

export default function Hero() {
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const marquee = [...profile.disciplines, ...profile.disciplines];

  return (
    <section className="relative pt-40 pb-16 md:pt-48 md:pb-24">
      <div className="container-wide">
        <div className="flex items-center gap-3 mb-8 reveal is-visible">
          <span className="w-2 h-2 rounded-full bg-[var(--accent)] animate-pulse" />
          <span className="section-label">Available for new work</span>
        </div>

        <h1 className="font-serif-display font-light leading-[0.98] tracking-[0.015em] text-[13vw] sm:text-[10vw] lg:text-[8.2vw] max-w-[16ch] text-balance">
          {profile.heroLine}
        </h1>

        <div className="mt-12 grid md:grid-cols-12 gap-8 items-end">
          <p className="md:col-span-6 lg:col-span-5 text-[17px] leading-relaxed text-[var(--muted)]">
            {profile.heroSub}
          </p>
          <div className="md:col-span-6 lg:col-span-7 md:justify-self-end flex flex-wrap gap-4">
            <button
              onClick={() => go("#work")}
              className="group inline-flex items-center gap-2 px-7 py-4 bg-[var(--ink)] text-[#FAFAF7] rounded-full text-[15px] hover:bg-[var(--accent)] transition-colors duration-300"
            >
              View selected work
              <ArrowDownRight
                size={18}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:translate-y-0.5"
              />
            </button>
            <button
              onClick={() => go("#contact")}
              className="group inline-flex items-center gap-2 px-7 py-4 border border-[var(--ink)] rounded-full text-[15px] hover:bg-[var(--ink)] hover:text-[#FAFAF7] transition-colors duration-300"
            >
              Get in touch
              <ArrowUpRight
                size={18}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </button>
          </div>
        </div>
      </div>

      {/* Discipline marquee */}
      <div className="mt-20 md:mt-28 border-y border-[var(--line)] py-5 overflow-hidden">
        <div className="marquee-track">
          {marquee.map((d, i) => (
            <span
              key={i}
              className="font-serif-display text-2xl md:text-3xl italic mx-8 text-[var(--ink)]/80 inline-flex items-center gap-8"
            >
              {d}
              <span className="text-[var(--accent)] not-italic text-lg">&#10022;</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
